import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const ForwardedCases = lazy(() => import('./ForwardedCases.jsx'))
const SingleForwardedCases = lazy(() => import('./SingleForwardedCases.jsx'))

const ForwardedCasesRoutes = [
    {
        path: '/ForwardedCases',
        component: ForwardedCases,
        auth: authRoleAccess.forwarded_cases,
    },

    {
        path: '/ForwardedCases/:id',
        component: SingleForwardedCases,
        auth: authRoleAccess.forwarded_cases,
    },

]

export default ForwardedCasesRoutes 